import { lazyAfterPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const AsyncFloatingSoftphoneCallBar: LazyComponent<() => React.JSX.Element | null> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyAfterPaint(
		() =>
			import(
				/* webpackChunkName: "async-floating-softphone-call-bar" */ '@jira/customer-service__live-conversations-common/src/FloatingSoftphoneCallBar.tsx'
			).then(({ FloatingSoftphoneCallBar }) => FloatingSoftphoneCallBar),
		{ ssr: false },
	);
